<template>
  <div class="com-footer">
    <div class="dn-center">
      <div class="com-content-1340">
        <div class="dn-nav">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'brand' }" class="dp-a1">品牌中心</router-link>
                </div>
                <div class="dn-bot">
                  <router-link :to="{name: 'introduce' }" class="dp-a1">品牌故事</router-link>
                  <router-link :to="{name: 'culture' }" class="dp-a1">品牌文化</router-link>
                  <router-link :to="{name: 'development' }" class="dp-a1">发展历程</router-link>
                  <router-link :to="{name: 'honor' }" class="dp-a1">荣誉资质</router-link>
                  <router-link :to="{name: 'layout' }" class="dp-a1">全球布局</router-link>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <a class="dp-a1" @click="clickSwitchProduct(1)">产品中心</a>
                </div>
                <div class="dn-bot">
                  <a class="dp-a1" @click="clickSwitchProduct(1)">产品分类</a>
                  <a class="dp-a1" @click="clickSwitchProduct(2)">定制化方案</a>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <a class="dp-a1" @click="clickSwitchNewsType(stateNews_getNewsType[0])">新闻中心</a>
                </div>
                <div class="dn-bot">
                  <a class="dp-a1" @click="clickSwitchNewsType(item)"
                     v-for="(item, index) in stateNews_getNewsType" :key="index">
                    {{ item.name }}
                  </a>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'user' }" class="dp-a1">用户中心</router-link>
                </div>
                <div class="dn-bot">
                  <router-link :to="{name: 'feedback' }" class="dp-a1">用户反馈</router-link>
                  <router-link :to="{name: 'policy' }" class="dp-a1">维保政策</router-link>
                  <router-link :to="{name: 'network' }" class="dp-a1">服务网点</router-link>
                  <router-link :to="{name: 'find' }" class="dp-a1">如何找到我们</router-link>
                  <router-link :to="{name: 'distinguish' }" class="dp-a1">如何识别皇冠工具</router-link>
                  <router-link :to="{name: 'guide' }" class="dp-a1">工具使用指南</router-link>
                  <router-link :to="{name: 'download' }" class="dp-a1">下载中心</router-link>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'contact' }" class="dp-a1">联系我们</router-link>
                </div>
                <div class="dn-bot">
                  <router-link :to="{name: 'contact2' }" class="dp-a1">联系方式</router-link>
                  <router-link :to="{name: 'join' }" class="dp-a1">我要代理</router-link>
                  <router-link :to="{name: 'recruit' }" class="dp-a1">招贤纳士</router-link>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="dn-share">
          <a href="" class="dp-a1"><i class="iconfont icon-facebook"></i></a>
          <a href="" class="dp-a1"><i class="iconfont icon-lingying"></i></a>
          <a href="" class="dp-a1"><i class="iconfont icon-google"></i></a>
          <a href="" class="dp-a1"><i class="iconfont icon-twitter"></i></a>
        </div>
      </div>
    </div>
    <div class="dn-lower">
      <div class="com-content-1340 com-content">
        <div class="dn-left">
          <div class="dn-nav">
            <div class="dp-a1">www.crown-tools.com</div>
            <div class="dp-a1">在线配置工具</div>
            <div class="dp-a1">企业信息</div>
            <div class="dp-a1">条款和条件</div>
            <div class="dp-a1">隐私政策</div>
            <div class="dp-a1">联系我们</div>
          </div>
          <div class="dn-list">
            <div class="dp-pai">
              {{ statePerInfor.copyright }}
              <a href="https://beian.miit.gov.cn" target="_blank">{{ statePerInfor.icp }}</a>
            </div>
            <div class="dp-pai">
              注册办公地址：{{ statePerInfor.address }}
            </div>
          </div>
        </div>
        <div class="dn-right">
          <div class="dn-list">
            <div class="dp-pai">
              <img :src="stateimgBaseURL+statePerInfor.imga_path" alt="" class="dp-img1">
              <div class="dp-p1">微信公众号</div>
            </div>
            <div class="dp-pai">
              <img :src="stateimgBaseURL+statePerInfor.imgb_path" alt="" class="dp-img1">
              <div class="dp-p1">手机官网</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(['stateimgBaseURL', 'statePerInfor', 'stateIndex_link', 'stateNews_getNewsType'])
  },
  created() {

  },
  methods: {
    clickSwitchProduct(item) {
      // this.$router.push('/product/' + item)
      this.$router.push({
        name: 'product',
        params: {
          class_id: item,
          zi_id: 'null',
        }
      })
    },
    clickSwitchNewsType(item) {
      this.$router.push('/news/' + item.id)
    },
  },
}
</script>

<style scoped lang="scss">
.com-footer {
  background: $background1;

  .dn-center {
    padding: 55*$pc-conversion 0 40*$pc-conversion;

    .dn-nav {
      .swiper1 {
        .wrapper1 {
          justify-content: space-between;
        }

        .slide1 {
          width: auto;

          .dn-top {
            font-size: 20px;
            font-weight: 600;

            .dp-a1 {
              color: #727376;
            }
          }

          .dn-bot {
            font-size: 16px;
            line-height: 30px;
            margin: 10*$pc-conversion 0 0;

            .dp-a1 {
              display: block;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
                color: $color2;
              }
            }
          }
        }
      }
    }

    .dn-share {
      margin: 20*$pc-conversion 0 0 260*$pc-conversion;
      width: 190px;
      height: 40px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .dp-a1 {
        i {
          font-size: 26px;
        }
      }
    }
  }

  .dn-lower {
    padding: 20*$pc-conversion 0;
    background: $background3;

    .com-content {
      display: flex;
      justify-content: space-between;
    }

    .dn-left {
      .dn-nav {
        display: flex;
        align-items: center;
        font-size: 16px;

        .dp-a1 {
          margin: 0 50*$pc-conversion 0 0;
          &:hover {
            text-decoration: underline;
            color: $color2;
          }
        }
      }

      .dn-list {
        padding: 10*$pc-conversion 0 0;

        .dp-pai {
          margin: 15*$pc-conversion 0 0;
          a{
            &:hover{
              color: $color2;
            }
          }
        }
      }
    }

    .dn-right {
      .dn-list {
        display: flex;

        .dp-pai {
          text-align: center;
          margin: 0 0 0 30*$pc-conversion;

          .dp-img1 {
            width: 95px;
            margin: 0 0 10*$pc-conversion;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .com-footer {
    .dn-center {
      padding: 55*$mobile-conversion 0 40*$mobile-conversion;

      .dn-nav {
        display: none;
      }

      .dn-share {
        margin: 0;
        width: 360*$mobile-conversion;
        height: 60*$mobile-conversion;

        .dp-a1 {
          i {
            font-size: 40*$mobile-conversion;
          }
        }
      }
    }

    .dn-lower {
      padding: 20*$mobile-conversion 0;

      .com-content {
        flex-wrap: wrap;
      }

      .dn-left {
        width: 100%;

        .dn-nav {
          font-size: 26*$mobile-conversion;
          flex-wrap: wrap;

          .dp-a1 {
            margin: 0 50*$mobile-conversion 0 0;
          }
        }

        .dn-list {
          padding: 10*$mobile-conversion 0 0;

          .dp-pai {
            margin: 15*$mobile-conversion 0 0;
          }
        }
      }

      .dn-right {
        width: 100%;
        margin: 30*$mobile-conversion 0 0 0;

        .dn-list {
          justify-content: flex-end;

          .dp-pai {
            margin: 0 0 0 30*$mobile-conversion;

            .dp-img1 {
              width: 110*$mobile-conversion;
              margin: 0 0 10*$mobile-conversion;
            }
          }
        }
      }
    }
  }
}
</style>
